// extracted by mini-css-extract-plugin
export default {"EmptyCartContainer":"EmptyCart_EmptyCartContainer__ljUXe"};